import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import StbType from "../components/stbtype.jsx";
import Footer from "../components/footer.jsx";

function StbTypepage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <StbType/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default StbTypepage;
